module.exports = __webpack_public_path__ + "assets/e46956b6d04ed6f1f242377654f54c10.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./public-src/sounds/drop/12/ScatterOrchHit04.mp3
 ** module id = 209
 ** module chunks = 0
 **/